<div class="popup-details-cont">
  <div class="slider">
    <splide [options]="sliderOptions" class="slider slider--pink slider--goal-rush howItWorks-swiper">
      @for (slide of slides; track $index) {
        <splide-slide class="how-it-works-goal-rush__slide">
          <div class="slide-block">
            <div class="textItems goal_rush_texItems">
              <div class="goal-rush-img">
                <img [src]="slide.img" alt="" class="m-auto mb-5" />
              </div>
              <div class="event-text goal_rush_event-text lg:px-14 slider-desc">
                <span [innerHTML]="slide.html"></span>
              </div>
            </div>
          </div>
        </splide-slide>
      }
    </splide>
  </div>
</div>
